import { render, staticRenderFns } from "./InitiaExpert.vue?vue&type=template&id=aefe6c62&scoped=true"
import script from "./InitiaExpert.vue?vue&type=script&lang=js"
export * from "./InitiaExpert.vue?vue&type=script&lang=js"
import style0 from "./InitiaExpert.vue?vue&type=style&index=0&id=aefe6c62&prod&lang=less&scoped=true"
import style1 from "./InitiaExpert.vue?vue&type=style&index=1&id=aefe6c62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefe6c62",
  null
  
)

export default component.exports